import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import globalCourseStore from '../../../../stores/global-course-store';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';

export const addNewStudentsOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  studentsIds: number[],
  selectedUsers: UserSummaryType[],
  setLoading: (loading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (!programId || !courseId || studentsIds.length === 0) {
      toast.warn('יש לבחור סטודנטים');
      return;
    }
    setLoading(true);
    await appApi.addStudentToCourse(programId, courseId, studentsIds);

    const currentCourse = globalCourseStore.getCurrentCourse();
    if (currentCourse?.details?.students) {
      const uniqueUsers = selectedUsers.filter(
        (selected) =>
          !currentCourse.details!.students.some(
            (student) => student.id === selected.id,
          ),
      );
      currentCourse.details.students.push(...uniqueUsers);
    }

    console.log(
      `XXX data res: ${JSON.stringify(globalCourseStore.getCurrentCourse())}`,
    );
    toast.success(`הפעולה התבצעה בהצלחה`);
    setLoading(false);
    closeDialog();
  } catch (e) {
    console.log(`addNewStudentsOperation is failed with the error: ${e}`);
    toast.error(`הוספת סדטונטים לקורס נכשלה, נסה שוב מאוחר יותר`);
    setLoading(false);
  }
};
